/**
 * KiekkoKingi section controller: simulator-booking
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
          const rootId = kkScript.dataset.rootId;
          const sectionId = kkScript.dataset.sectionId;
          const destroy = (root) => {
            if (!root || typeof root.__kiekkokingiBookingCleanup !== 'function') return;
            root.__kiekkokingiBookingCleanup();
            root.__kiekkokingiBookingCleanup = null;
            root.removeAttribute('data-simulator-booking-initialized');
          };
  
          const init = (root) => {
            if (!root || root.hasAttribute('data-simulator-booking-initialized')) return;
            const frame = root.querySelector('[data-simulator-booking-frame]');
            const loading = root.querySelector('[data-simulator-booking-loading]');
            if (!frame) return;
  
            root.setAttribute('data-simulator-booking-initialized', 'true');
            const onLoad = () => {
              if (loading) loading.hidden = true;
            };
            frame.addEventListener('load', onLoad);
            root.__kiekkokingiBookingCleanup = () => frame.removeEventListener('load', onLoad);
          };
  
          const onSectionLoad = (event) => {
            if (!event.detail || event.detail.sectionId !== sectionId) return;
            init(event.target.querySelector('[data-kiekkokingi-simulator-booking]') || document.getElementById(rootId));
          };
          const onSectionUnload = (event) => {
            if (!event.detail || event.detail.sectionId !== sectionId) return;
            destroy(event.target.querySelector('[data-kiekkokingi-simulator-booking]') || document.getElementById(rootId));
            document.removeEventListener('shopify:section:load', onSectionLoad);
            document.removeEventListener('shopify:section:unload', onSectionUnload);
          };
  
          init(document.getElementById(rootId));
          document.addEventListener('shopify:section:load', onSectionLoad);
          document.addEventListener('shopify:section:unload', onSectionUnload);
        })();
})();